import React from 'react'
import PropTypes from 'prop-types'

import SortControls from './SortControls'

const TableColumnSchema = PropTypes.shape({
	label: PropTypes.string,
	sortKey: PropTypes.string,
	getValue: PropTypes.func,
	prop: PropTypes.string,
})

function TableColumn(args={}) {
	// defaults 
	this.label = ''
	// register default getter function for cell value
	this.getValue = (doc) => {
		return doc[this.prop];
	}
	// map args onto self
	Object.entries(args).forEach(([key, value]) => this[key] = value);
}

export default class Table extends React.Component {

	static propTypes = {
		columns: PropTypes.arrayOf(TableColumnSchema),
		data: PropTypes.arrayOf(PropTypes.object),
		rowLinks: PropTypes.func,
		// sorting values/handler
		sortBy: PropTypes.string,
		sortKey: PropTypes.string,
		onChangeSort: PropTypes.func,
	};

	static defaultProps = {
		data: [],
		rowLinks: undefined,
	};

	constructor(props) {
		super(props);
		this.columns = props.columns.map((o, i) => new TableColumn(o));
	}

	render() {
		const headers = this.renderHeaders();
		const rows = this.renderRows();
		return (
			<table>
				<thead>
					{headers}
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}

	renderHeaders() {
		const { 
			onChangeSort, 
			sortBy, 
			sortDir,
			rowLinks
		} = this.props;

		const tableHeaders = this.columns.map((column, i) => (
			<th key={i}>
				{ column.label &&
					<span>{column.label}</span>
				}
				{ column.sortKey && 
					<SortControls 
						sortKey={column.sortKey}
						currentSortBy={sortBy}
						currentSortDir={sortDir}
						onChangeSort={onChangeSort}
					/>
				}
			</th>
		));

		if(rowLinks) {
			tableHeaders.push(<th key='rowLinks'></th>)
		}
		return <tr key="tableHeaders">{tableHeaders}</tr>;
	}

	renderRows() {
		const { data } = this.props;
		return data.map(::this.renderRow);
	}

	renderRow(doc, index) {
		const { rowLinks } = this.props;
		const attrs = {};

		let cells = this.columns.map((column, i) => {
			let value = column.getValue(doc);
			if(column.sortKey) {
				// Grab value for data-attributes
				attrs[`data-${column.sortKey.toLowerCase()}`] = value;
			}
			return <td key={i}>{value}</td>;
		});

		if(rowLinks) {
			cells.push(<td key='rowLinks'>{rowLinks(doc)}</td>);
		}
		return <tr {...attrs} key={index}>{cells}</tr>;
	}

}



// WEBPACK FOOTER //
// ./src/components/DataTable/components/Table.jsx